module.exports = __webpack_public_path__ + "img/feature_buy_my.65a55638.png";